<template>
    <FilterExpandCollapse label="Locations" :expand="expanded">
      <div>
        <BaseFCPTextSelect :key="key" elementId="distance-filter" label="Within" labelSize="xs" :items="options" v-model="filterContext.distance" />
        <hp5-spacing-vertical xs="xs" sm="xs" md="xs" lg="xs"></hp5-spacing-vertical>
        <hp5-horizontal-rule />
        <hp5-spacing-vertical xs="xs" sm="xs" md="xs" lg="xs"></hp5-spacing-vertical>
        <hp5-heading tag-selection="p" size-selection="xs">Availability</hp5-heading>
        <FilterAvailabilityOptions />
      </div>
    </FilterExpandCollapse>
</template>

<script setup>

    const model = useFCPModel()
    const { filterContext } = model
    const options = [
        { label: '5 miles', value: 5 },
        { label: '10 miles', value: 10 },
        { label: '20 miles', value: 20 },
        { label: '50 miles', value: 50 },
        { label: '75 miles', value: 75 },
    ]
    const key = computed(() => (options.value ? JSON.stringify(options.value) : 'default_key'))
    const expanded = computed(() => (filterContext.value.distance ? true : false))

</script>
  
<style scoped>
  label {
    padding-left: var(--spacing-xxs);
  }
</style>